import script from "./test-quote-management.vue?vue&type=script&setup=true&lang=js"
export * from "./test-quote-management.vue?vue&type=script&setup=true&lang=js"

import "./test-quote-management.vue?vue&type=style&index=0&id=24ff47d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ff47d6"]])

export default __exports__